import Spinner from '@/components/Spinner'
import styles from './PageLoader.module.css'

export default function PageLoader() {
  return (
    <div className={styles.wrap} role="status" aria-live="polite">
      <Spinner />
    </div>
  )
}
